import styled from 'styled-components';
import { StyledTextInput } from '../../pages/InputPage/InputPage.styled';

export const AddressSearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const AddressInput = styled(StyledTextInput)`
  background-color: white;
  border: 2px solid ${(props) => props.theme.ecoMint};
  border-radius: 8px;
  width: ${(props) => (props.width ? props.width : '80%')};
  height: ${(props) => (props.height ? props.height : '40px')};
  display: ${(props) => (props.display ? props.display : 'flex')};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
  padding: 0 10px;
  z-index: 2;

  &:focus {
    border: 2px solid ${(props) => props.theme.highlightBlue};
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
  }
`;

export const SuggestionsList = styled.div`
  position: absolute;
  top: calc(100% - 8px);
  left: 0;
  background: white;
  border: 2px solid ${(props) => props.theme.highlightBlue};
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 300px;
  padding: 8px 10px 0px 10px;
  width: ${(props) => (props.width ? props.width : '80%')};
  overflow-y: auto;
  z-index: 1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const SuggestionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.paleGreen};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const LoadingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  color: ${(props) => props.theme.logoGreen};
  font-style: italic;

  &:last-child {
    border-bottom: none;
  }
`;

export const SuggestionText = styled.div`
  flex: 1;

  div {
    font-size: 1rem;
    color: ${(props) => props.theme.headerBlue};
    margin-bottom: 2px;
    line-height: 1.3;
  }
`;

export const ConfidenceScore = styled.div`
  font-size: 0.85rem !important;
  color: ${(props) => props.theme.logoGreen} !important;
  font-style: italic;
  margin-bottom: 0 !important;
`;

export const NoResultsText = styled.div`
  margin-top: 0.2rem;
  position: absolute;
  font-size: 0.8rem;
  font-style: italic;
  text-align: left;
  z-index: 0;
`;
